"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CoreQuadList_1 = require("../../tree/core/CoreQuadList");
class C2dCoreQuadList extends CoreQuadList_1.CoreQuadList {
    constructor() {
        super(...arguments);
        this.renderContexts = [];
        this.modes = [];
    }
    setRenderContext(index, v) {
        this.renderContexts[index] = v;
    }
    setSimpleTc(index, v) {
        if (v) {
            this.modes[index] |= 1;
        }
        else {
            this.modes[index] -= this.modes[index] & 1;
        }
    }
    setWhite(index, v) {
        if (v) {
            this.modes[index] |= 2;
        }
        else {
            this.modes[index] -= this.modes[index] & 2;
        }
    }
    getRenderContext(index) {
        return this.renderContexts[index];
    }
    getSimpleTc(index) {
        return this.modes[index] & 1;
    }
    getWhite(index) {
        return this.modes[index] & 2;
    }
}
exports.C2dCoreQuadList = C2dCoreQuadList;
//# sourceMappingURL=C2dCoreQuadList.js.map